/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 10:22:37
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-31 15:53:48
 */
import template from './template.html';

/**
 * RangePickerControl
 */
export default class RangePickerControl {
  $input: JQuery;
  options: any;
  runnerChangeValue: any;
  $html: JQuery;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this.$input = $input;
    this.options = options;
    this.renderTemplate();
  }

  /**
   * Render Input to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    this.$input.hide();
    const configs = {
      name: this.$input.data('name'),
      value: this.$input.val(),
      valueType: this.$input.data('valuetype'),
      min: this.$input.data('min') || 0,
      max: this.$input.data('max') || 100,
      step: this.$input.data('step') || 1,
    };
    const html = template(configs);

    this.$html = $(html);

    (this.$html.find('.gf-range-picker-slider') as any).slider({
      value: configs.value,
      min: configs.min,
      max: configs.max,
      step: configs.step,
      /**
       * Sliding
       * @param _event ..
       * @param ui ..
       */
      slide: function (_event: any, ui: any) {
        const value = ui.value;
        _this.$html.find('.gf-range-picker-text input').val(value);
      },
      /**
       * Stop slider
       * @param _event ..
       * @param ui ..
       */
      stop: function (_event: any, ui: any) {
        const name = _this.$input.data('name') || '';
        const value = ui.value;

        const data = {
          name: name,
          value: value,
        };
        if (_this.options && _this.options.onChange) {
          _this.options.onChange(data);
        }
      },
    });

    const $rangePickerText = this.$html.find('.gf-range-picker-text input');
    $rangePickerText.off('keyup paste').on('keyup paste', function () {
      _this.runnerChangeValue && clearTimeout(_this.runnerChangeValue);
      _this.runnerChangeValue = setTimeout(() => {
        let value = $rangePickerText.val() || '';
        if (value == '') value = _this.$input.data('min');

        if (value !== '') {
          const name = _this.$input.data('name') || '';
          const data = {
            name: name,
            value: value.toString(),
          };
          if (_this.options && _this.options.onChange) {
            _this.options.onChange(data);
            _this.setValue(value.toString());
          }
        }
      }, 600);
    });

    this.$input.after(this.$html);
  }

  /**
   * Set value to input
   * @param val ..
   * @returns void
   */
  setValue(val: string): void {
    this.$input.val(val);

    const $gfRangePicker = this.$input.next();
    const $rangePickerScoll = $gfRangePicker.find('.gf-range-picker-slider span');
    const $rangePickerText = $gfRangePicker.find('.gf-range-picker-text input');

    const max = parseFloat(this.$input.data('max'));
    const min = parseFloat(this.$input.data('min'));
    if (val === '' || val == 'auto') {
      $rangePickerText.val(val);
      val = min.toString();
    } else {
      if (val[val.length - 1] !== '.') {
        val = (Math.round(parseFloat(val) * 100) / 100).toString();
      }
      //thả cửa trường hợp value lớn hơn max (vì vẫn có trường hợp khách muốn lớn hơn max. Nhỏ hơn min thì hiếm :D)
      if (parseFloat(val) < parseFloat(min.toString())) {
        val = min.toString();
      }
      $rangePickerText.val(val);
    }

    // var percentage = Math.abs(value - min);
    const percentage = parseFloat(val) - min;
    const distance = Math.abs(max - min);
    let left = (percentage / distance) * 100;
    if (left > 100) {
      left = 100;
    } else if (left < 0) {
      left = 0;
    }
    $rangePickerScoll.css({
      left: left + '%',
    });
  }
}
